import axios from 'axios'
import Const from '@/helper/const'

export default {
  mediaClassifier (data) {
    return axios.post(`${Const.API_MEDIA_CLASSIFIER}/check_url`, data)
  },
  mediaClassifierFeedback (data) {
    return axios.put(`${Const.API_MEDIA_CLASSIFIER}/feedback`, data)
  }
}
